(function($) {
    class PostLoader {
        constructor() {
            this.wp_query = window._mgw_wp_query;
            this.el = $('.js-postsloader');

            if (Object.prototype.toString.call(window._mgw_state) === '[object Array]') {
                this.state = {};
            } else {
                this.state = window._mgw_state;
            }

            if (! this.el) return;

            this.filtersState = [];
            this.xhr = null;

            this.ui = {
                form: this.el.find('.js-postsloader-form'),
                submitBtn: this.el.find('button.forms__button'),
                container: this.el.find('.ajaxContainer'),
                badges: this.el.find('.filtersState__badges'),
                pagination: $('.js-pagination'),
                resetBtn: this.el.find('.filtersState__reset')
            }

            if (window._mgw_is_calendar) {
                this.ui.eventslist_day = this.el.find('input[name="eventslist_day"]');
                this.ui.eventslist_month = this.el.find('select[name="eventslist_month"]');
                this.ui.eventslist_range_1 = this.el.find('input[name="eventslist_range_1"]');
                this.ui.eventslist_range_2 = this.el.find('input[name="eventslist_range_2"]');
            }

            this.uistate = {
                loading: false,
                fromPopstate: false
            }

            this.init();
        }

        events() {
            let self = this;

            this.ui.form.on('submit', e => {
                e.preventDefault();

                this.ui.submitBtn.blur();

                this.state.page = 1;
                this.doRequest();
            });

            this.ui.form.find('select').on('change', e => {
                const el = $(e.target);
                let type = el.data('type');

                // update badges state
                this.setBadgesState(el);

                // update values state
                this.state[type] = el.val();
            });

            this.ui.form.find('input[type="radio"], input[type="checkbox"]').on('change', e => {
                const el = $(e.target);
                let type = el.data('type');

                // update badges state
                this.setBadgesState(el);

                if (el.is(':checked')) {
                    this.state[type] = el.val();
                } else {
                    delete this.state[type];
                }
                console.log(this.state);
            });

            this.ui.pagination.on('click', 'a', e => {
                e.preventDefault();

                this.state.page = e.target.getAttribute('data-page');
                this.doRequest();
                $('body, html').stop().animate({
                    scrollTop: this.el.offset().top - 20 
                })
            });

            this.ui.badges.on('click', 'button', function(e) {
                e.preventDefault();
                let me = $(this),
                    type = me.data('type'),
                    value = me.data('value'),
                    tgtsel = self.ui.form.find('[data-type="' + type + '"]'),
                    tagname = tgtsel.prop('tagName').toLowerCase();
                
                console.log(tagname);
                if (tagname == 'input') {
                    let tgt = tgtsel.filter(':checked');
                    tgt.prop('checked', false);
                    tgt.trigger('change');
                }

                if (tagname == 'select') {
                    tgtsel.find('option[value="' + value + '"]').prop('selected', false);
                    tgtsel.selectric('refresh');
                    tgtsel.trigger('change');
                }

                self.doRequest();
            });
        }

        selectrics() {
            this.el.find('.forms__select').selectric({
                multiple: {
                    separator: ', ',
                    keepMenuOpen: true
                }
            });

            $('input.selectric-input').prop('type', 'hidden');
        }

        doRequest() {
            const self = this;

            if (this.ui.eventslist_day) {
                this.state.eventslist_day = this.ui.eventslist_day.val();
                this.state.eventslist_month = this.ui.eventslist_month.val();
                this.state.eventslist_range_1 = this.ui.eventslist_range_1.val();
                this.state.eventslist_range_2 = this.ui.eventslist_range_2.val();
            }

            this.pushState();

            if (this.xhr) {
                this.xhr.abort();
            }

            this._setLoadingState(true);

            this.xhr = $.ajax({
                type: 'GET',
                url: window.ajaxurl,
                data: {
                    action: 'theme_postsloader',
                    wp_query: self.wp_query,
                    state: self.state
                },
                dataType: 'json',
                success: function(response) {
                    this.xhr = null;
                    self.render(response.posts);
                    self.renderPagination(response.pagination)
                    self.postRequestSetup(response);
                },
                error: function(error) {
                    this.xhr = null;
                    console.log('error');
                }
            });
        }

        pushState() {
            if (! this.uistate.fromPopstate) {
                let state = Object.assign({}, this.state);
                delete state.post_type;
                delete state.posts_per_page;

                const params = '?' + $.param(state);
                history.pushState(null, null, params);
            } else {
                this.uistate.fromPopstate = false;
            }
        }

        setBadgesState(el) {
            let type = el.data('type'),
                values = el.val();
            
            if (typeof values == 'string' && values) {
                values = [el.val()];
            }

            if (el.prop('tagName').toLowerCase() == 'input') {
                if (! el.is(':checked')) {
                    values = null;
                }
            }
            
            if (! values) {
                this.filtersState = this.filtersState.filter(badge => {
                    if (badge.type == type) return false;
                    return true;
                });
            }

            // add new positions
            if (values) {
                values.forEach(value => {
                    let exists = this.filtersState.find(badge => {
                        if (badge.value == value && badge.type == type) return true;
                        return false;
                    });
                    if (! exists) {
                        let label;
                        if (el.data('label')) {
                            label = el.data('label');
                        } else {
                            label = el.find('option[value="' + value + '"]').text();
                        }
                        this.filtersState.push({
                            type: type,
                            value: value,
                            label: label
                        });
                    }
                });
    
                // remove not existing
                this.filtersState = this.filtersState.filter(badge => {
                    if (badge.type == type && values.indexOf(badge.value) < 0) return false;
                    return true;
                });
            }

            this.renderBadges();
        }

        renderBadges() {
            let result = '';
            this.filtersState.forEach(badge => {
                result += `<button class="filtersState__badge" data-type="${badge.type}" data-value="${badge.value}" data-label="${badge.label}"><span>${badge.label}</span><em class="icon-clear"></em></button> `;
            });

            if (this.filtersState.length) {
                this.ui.resetBtn.removeClass('is-hidden');
            } else {
                this.ui.resetBtn.addClass('is-hidden');
            }

            this.ui.badges.html(result);
        }

        renderPagination(code) {
            this.ui.pagination.html(code);
        }

        render(posts) {
            this.ui.container.find('article').remove();
            this.ui.container.find('.dateHeader').remove();
            this.ui.container.append(posts);
        }

        postRequestSetup(data) {
            this._setLoadingState(false);
            data.posts.length ? this._setNoResults(false) : this._setNoResults(true);
            if (! this.ui.eventslist_day) {
                $(window).trigger('resize');
            }
        }

        initFiltersState() {
            this.filtersState = [];
            let badges = document.querySelectorAll('.filtersState__badge');
            badges.forEach(badge => {
                this.filtersState.push({
                    type: badge.getAttribute('data-type'),
                    value: badge.getAttribute('data-value'),
                    label: badge.getAttribute('data-label'),
                });
            });

            console.log(this.filtersState);
        }

        _setLoadingState(towhat) {
            window.isloading = towhat;
            this.uistate.loading = towhat;
            this.ui.submitBtn.prop('disabled', towhat);
            towhat ? this.el.addClass('is-loading') : this.el.removeClass('is-loading');
        }

        _setNoResults(towhat) {
            towhat ? this.el.addClass('noresults') : this.el.removeClass('noresults');
        }

        handlePopstate(e) {
            this.uistate.fromPopstate = true;
            window.location.reload();
        }

        init() {
            this.initFiltersState();
            this.events();
            this.selectrics();

            window.addEventListener('popstate', this.handlePopstate.bind(this));
        }
    }

    const App_PostLoader = {
        init: function() {
            if ($('.js-postsloader').length) {
                new PostLoader();
            }
        }
    }

    $(document).ready(function() {
        App_PostLoader.init();
    });

})(jQuery)